// extracted by mini-css-extract-plugin
module.exports = {"TagChip":"TagChip_TagChip__3X0Yv"};